import { apiBff } from '@/api'

export interface CzListSet {
  customZone: string
  designation: string
  reference: string
  sales_organization: string
}

interface CzListSetResponse {
  items: Array<{
    custom_zone: string
    cz_designation: string
    reference_cz: string
    sales_organization: string
  }>
}

export async function fetchCzListSets(): Promise<CzListSet[]> {
  const response = await apiBff.callDirectBFF<CzListSetResponse>(
    'GET',
    `/sap-md/czListSet`,
  )

  return response.items.map(result => ({
    customZone: result.custom_zone,
    designation: result.cz_designation,
    reference: result.reference_cz,
    sales_organization: result.sales_organization,
  }))
}
